module.exports = __webpack_public_path__ + "img/wallace-college.053d285d.jpg";